const initialState = {
   loading: false, data: [], error: null 
};

export default function toDoReducer(state = initialState, action) {
    switch (action.type) {
        case "TO_DO_LOADING":
            return { ...state, loading: true, data: [], error: null };
        case "TO_DO_SUCCESS":
            return { ...state, loading: false, data: action.payload, error: null };
        case "TO_DO_ERROR":
            return { ...state, loading: false, data: [], error: action.payload };

        default:
            return state;
    }
}
